module.exports = __webpack_public_path__ + "img/bm.ec1620c5.svg";